// extracted by mini-css-extract-plugin
export default {"footer_wrapper":"Footer_footer_wrapper__CZyWS","footer":"Footer_footer__+auRc"};